import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { useDelIroStakeholderLinkMutation, useListIroStakeholderLinksQuery, useListStakeholdersLazyQuery, useUpdateIroStakeholderLinkMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'IroStakeholderLink',
  setup: function setup(__props) {
    // FIXME warning: this file shares lots of similarities with activity-stakeholder-links, we might need to merge them into one table in the future
    var headerConfig = {
      id: {
        sortable: true
      },
      'stakeholder.name': {},
      'stakeholder.type': {},
      'stakeholder.description': {},
      impactMaterial: {},
      financialMaterial: {},
      actions: {
        value: 'actions',
        width: '30px',
        text: ' ',
        cellClass: 'max-w-[30px]'
      },
      howAffected: {},
      relationToRo: {}
      // concernsAndRequirements: {},
    };
    var attrs = useAttrs();
    var headers = computed(function () {
      return attrs === null || attrs === void 0 ? void 0 : attrs.headers.map(function (h) {
        return _objectSpread(_objectSpread({
          value: h.value || h
        }, headerConfig[h.value || h]), _typeof(h) === 'object' && h !== null ? h : {});
      });
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var search = ref('');
    var variables = computed(function () {
      return {
        iroId: attrs['iro-id'],
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListIroStakeholde = useListIroStakeholderLinksQuery(variables, computed(function () {
        return {
          enabled: !!variables.value.iroId
        };
      })),
      result = _useListIroStakeholde.result,
      refetch = _useListIroStakeholde.refetch,
      loading = _useListIroStakeholde.loading;
    var iroId = computed(function () {
      return attrs['iro-id'];
    });
    var _useListStakeholdersL = useListStakeholdersLazyQuery(computed(function () {
        return {
          filters: {
            iroIds: iroId.value ? [iroId.value] : []
          }
        };
      })),
      loadStakeholders = _useListStakeholdersL.load,
      refetchStakeholders = _useListStakeholdersL.refetch;
    var items = computed(function () {
      var _result$value$listIro, _result$value;
      return (_result$value$listIro = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listIroStakeholderLinks) !== null && _result$value$listIro !== void 0 ? _result$value$listIro : [];
    });
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countIroStakeholderLinks) || 0;
    });
    var _useUpdateIroStakehol = useUpdateIroStakeholderLinkMutation(),
      updateIroStakeholderLink = _useUpdateIroStakehol.mutate,
      onDone = _useUpdateIroStakehol.onDone;
    var _useDelIroStakeholder = useDelIroStakeholderLinkMutation(),
      delIroStakeholderLink = _useDelIroStakeholder.mutate,
      delLoading = _useDelIroStakeholder.loading;
    onDone(function () {
      // lists the stakeholders for this IRO, so cache is updated.
      loadStakeholders() || refetchStakeholders();
      window.$nuxt.$emit('userMsg');
    });
    return {
      __sfc: true,
      headerConfig: headerConfig,
      attrs: attrs,
      headers: headers,
      options: options,
      search: search,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      iroId: iroId,
      loadStakeholders: loadStakeholders,
      refetchStakeholders: refetchStakeholders,
      items: items,
      itemCount: itemCount,
      updateIroStakeholderLink: updateIroStakeholderLink,
      onDone: onDone,
      delIroStakeholderLink: delIroStakeholderLink,
      delLoading: delLoading
    };
  }
});